import type { AppMode } from '@/domain/types';

export interface AppConfig {
  mode: AppMode;
  supabaseUrl: string | null;
  supabaseAnonKey: string | null;
  appUrl: string;
}

export function loadConfig(): AppConfig {
  const modeRaw = (import.meta.env.VITE_APP_MODE as string | undefined) ?? 'demo';
  const mode: AppMode = modeRaw === 'production' ? 'production' : 'demo';

  const anon =
    (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ||
    (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined) ||
    null;

  return {
    mode,
    supabaseUrl: (import.meta.env.VITE_SUPABASE_URL as string | undefined) || null,
    supabaseAnonKey: anon,
    appUrl: (import.meta.env.VITE_APP_URL as string | undefined) || window.location.origin,
  };
}

export function isConfigValid(config: AppConfig): boolean {
  if (config.mode === 'demo') return true;
  if (!config.supabaseUrl || !config.supabaseAnonKey) return false;
  if (config.supabaseUrl.includes('your-project') || config.supabaseUrl.includes('YOUR_PROJECT')) {
    return false;
  }
  if (
    config.supabaseAnonKey.includes('your-anon') ||
    config.supabaseAnonKey.includes('YOUR_SUPABASE')
  ) {
    return false;
  }
  return true;
}

export const config = loadConfig();
